import _regenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/regenerator.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.function.name";
import { login as _login, proLogin, viewLogin, logout, getInfo, getCurrentUserInfo } from '@/api/user';
import { getToken, setToken, removeToken, getHywRole, setHywRole, removeHywRole, getRoleView, setRoleView, removeRoleView, setUserPermission, removeUserPermission, setUserIsSuperAdmin, removeUserIsSuperAdmin } from '@/utils/auth';
import store from '@/store';
import router, { resetRouter } from '@/router';
var state = {
  token: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  roles: '',
  hywRoles: getHywRole(),
  rolesViews: getRoleView(),
  userPermission: {},
  isSuperman: '',
  account: ''
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
    state.introduction = introduction;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_ROLESVIEW: function SET_ROLESVIEW(state, rolesViews) {
    state.rolesViews = rolesViews;
  },
  SET_USERPERMISSION: function SET_USERPERMISSION(state, permissions) {
    state.userPermission = permissions;
  },
  SET_IS_SUPERMAN: function SET_IS_SUPERMAN(state, is_superman) {
    state.isSuperman = is_superman;
  },
  SET_ACCOUNT: function SET_ACCOUNT(state, account) {
    state.account = account;
  }
};
var actions = {
  // user login
  login: function login(_ref, loginParams) {
    var commit = _ref.commit;
    var phone = loginParams.phone,
      password = loginParams.password,
      user_type = loginParams.user_type;
    return new Promise(function (resolve, reject) {
      //0 一般管理员用户(13312341234/123456)；1 专员管理(18812341234/123456)；2 外部用户(13812345678/123456)
      (user_type == 0 || user_type == 1 ? user_type == 0 ? _login : proLogin : viewLogin)({
        phone: phone.trim(),
        password: password
      }).then(function (response) {
        if (!response.data.success) {
          reject(response.data.message);
        }
        var data = response.data.data;
        console.log(data, '==========');
        // commit('SET_ROLES', data.user.roles) // 注释该行，让permission.js在登陆的时候执行路由生成方法
        commit('SET_ROLESVIEW', data.user.rolesView || []);
        commit('SET_TOKEN', data.token);
        commit('SET_NAME', data.user.name);
        commit('SET_AVATAR', data.user.avatar);
        commit('SET_INTRODUCTION', data.user.introduction);
        commit('SET_USERPERMISSION', data.permissions || []);
        commit('SET_IS_SUPERMAN', data.user.is_superman);
        commit('SET_ACCOUNT', data.user.account);
        setToken(data.token);
        setRoleView(data.user.rolesView || []);
        setHywRole(data.user.roles || []);
        setUserPermission(data.permissions || []);
        setUserIsSuperAdmin(data.user.is_superman);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // get user info
  getInfo: function getInfo(_ref2) {
    var commit = _ref2.commit,
      state = _ref2.state;
    return new Promise(function (resolve, reject) {
      getCurrentUserInfo().then(function (rep) {
        if (rep.data.success) {
          var roles = (rep.data.data['roles'] || []).length === 0 ? ['editor'] : rep.data.data['roles'];
          var views = rep.data.data['rolesView'] || [];
          // roles must be a non-empty array
          if (!roles || roles.length <= 0) {
            reject('getInfo: roles must be a non-null array!');
          }
          commit('SET_ROLES', roles);
          commit('SET_USERPERMISSION', rep.data.data['permissions']);
          commit('SET_IS_SUPERMAN', rep.data.data['is_superman']);
          resolve({
            roles: roles,
            views: views,
            isSuperman: rep.data.data['is_superman'] || 0
          });
        } else {
          store.dispatch('user/resetToken').then(function () {
            location.reload();
          });
        }
      });
    });
  },
  // user logout
  logout: function logout(_ref3) {
    var commit = _ref3.commit,
      state = _ref3.state,
      dispatch = _ref3.dispatch;
    return new Promise(function (resolve, reject) {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      commit('SET_ROLESVIEW', []);
      removeHywRole();
      removeRoleView();
      removeToken();
      resetRouter();
      removeUserIsSuperAdmin();
      // reset visited views and cached views
      // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
      dispatch('tagsView/delAllViews', null, {
        root: true
      });
      resolve();
    });
  },
  // remove token
  resetToken: function resetToken(_ref4) {
    var commit = _ref4.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      commit('SET_ROLESVIEW', []);
      removeHywRole();
      removeRoleView();
      removeToken();
      resolve();
    });
  },
  // dynamically modify permissions
  changeRoles: function changeRoles(_ref5, role) {
    var commit = _ref5.commit,
      dispatch = _ref5.dispatch;
    return new Promise(/*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(resolve) {
        var token, _yield$dispatch, roles, accessRoutes;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              token = role + '-token';
              commit('SET_TOKEN', token);
              setToken(token);
              _context.n = 1;
              return dispatch('getInfo');
            case 1:
              _yield$dispatch = _context.v;
              roles = _yield$dispatch.roles;
              resetRouter();

              // generate accessible routes map based on roles
              _context.n = 2;
              return dispatch('permission/generateRoutes', roles, {
                root: true
              });
            case 2:
              accessRoutes = _context.v;
              // dynamically add accessible routes
              router.addRoutes(accessRoutes);

              // reset visited views and cached views
              dispatch('tagsView/delAllViews', null, {
                root: true
              });
              resolve();
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref6.apply(this, arguments);
      };
    }());
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};